<template>
  <van-list
    v-model:loading="loading"
    :finished="finished"
    loading-text=" "
    finished-text="中山日报 中山+ 出品"
    @load="onLoad"
    class="content-list"
  >
    <van-cell-group inset class="group-top index" v-if="myComments.length == 0">
      <van-cell>
        <van-empty class="custom-image" description="您还未发布评论" />
      </van-cell>
    </van-cell-group>
    <van-cell-group
      inset
      :class="index == 0 ? 'group-top index' : 'group-top'"
      v-for="(item, index) in myComments"
      :key="index"
      :item="item"
      :index="index"
    >
      <van-cell>
        <template #title>
          <div class="list-content van-multi-ellipsis--l3">
            {{ item.user_comment }}
          </div>
          <div class="custom_mycoment">
            <div class="detail_right">{{ dealDate(item.createtime) }}</div>
            <div class="detail_left">
              <span
                v-if="item.status_text === '待审核'"
                class="custom_status"
                >{{ item.status_text }}</span
              >
              <span
                v-else
                class="custom_status"
                :class="item.status_text === '已通过' ? 'g' : 'r'"
                >{{ item.status_text }}</span
              >
            </div>
          </div>
        </template>
        <template #label>
          <div @click="handleClick(item.comhelp_content_id)">
            <div class="custom_title">
              <div class="list-title van-multi-ellipsis--l2">
                {{ item.content.nickname }}
              </div>
              <!-- <van-icon name="arrow" color="#FF8831" class="title-more" /> -->
            </div>
            <div class="list-content van-multi-ellipsis--l3">
              {{ item.content.user_content }}
            </div>
            <div class="custom-box">
              <van-grid
                v-if="item.content.images.length === 1"
                class="custom-img2"
                :column-num="1"
                :border="false"
              >
                <van-grid-item
                  class="content-image"
                  v-for="(image, index) in item.content.images"
                  :key="index"
                  :column-num="item.content.images.length"
                >
                  <van-image
                    fit="fit"
                    :src="image"
                    @click="imgClick(item.content.images, index)"
                    @click.stop
                  />
                </van-grid-item>
              </van-grid>
              <van-grid
                v-if="
                  item.content.images.length === 2 ||
                  item.content.images.length === 4
                "
                class="custom-img2"
                direction="horizontal"
                square
                :gutter="5"
                :column-num="2"
                :border="false"
              >
                <van-grid-item
                  class="content-image"
                  v-for="(image, index) in item.content.images"
                  :key="index"
                  :column-num="item.content.images.length"
                >
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="image"
                    @click="imgClick(item.content.images, index)"
                    @click.stop
                  />
                </van-grid-item>
              </van-grid>
              <van-grid
                v-if="
                  item.content.images.length === 3 ||
                  item.content.images.length === 5 ||
                  item.content.images.length === 6
                "
                class="custom-img"
                direction="horizontal"
                square
                :gutter="5"
                :column-num="3"
                :border="false"
              >
                <van-grid-item
                  class="content-image"
                  v-for="(image, index) in item.content.images"
                  :key="index"
                  :column-num="item.content.images.length"
                >
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="image"
                    @click="imgClick(item.content.images, index)"
                    @click.stop
                  />
                </van-grid-item>
              </van-grid>
              <!-- <van-grid
              class="custom-img"
              :border="false"
              v-for="(image, index) in item.content.images"
              :key="image"
              direction="horizontal"
              :column-num="item.content.images.length"
              :gutter="0"
            >
              <van-grid-item class="content-image">
                <van-image
                  v-if="item.content.images.length === 1"
                  width="233px"
                  height="282px"
                  fit="cover"
                  :src="image"
                  @click="imgClick(index)"
                  @click.stop
                />
                <van-image
                  v-else-if="item.content.images.length % 3 === 0"
                  width="92px"
                  height="92px"
                  fit="cover"
                  :src="image"
                  @click="imgClick(index)"
                  @click.stop
                />
                <van-image
                  v-else-if="item.content.images.length % 2 === 0"
                  width="114px"
                  height="114px"
                  fit="cover"
                  :src="image"
                  @click="imgClick(index)"
                  @click.stop
                />
              </van-grid-item>
            </van-grid> -->
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
  </van-list>
</template>

<script>
import {
  List,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  PullRefresh,
  Icon,
  Button,
  Image as VanImage,
  ImagePreview,
  Divider,
  Empty,
} from "vant";
import useDateDiff from "@/composiables/useDateDiff.js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
export default {
  name: "ContentCell",
  props: { item: Object, index: Number },
  components: {
    [Empty.name]: Empty,
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [Divider.name]: Divider,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const page = ref(1);

    const onLoad = () => {
      const params = {
        page: page.value,
        pageSize: 20,
      };
      store.dispatch("myComment", { params, loading, finished, refreshing });
      page.value++;
    };

    const onRefresh = () => {
      finished.value = false;
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    const imgClick = (index) => {
      console.log(props);
      ImagePreview({
        images: props.item.images,
        startPosition: index,
        closeable: true,
      });
    };

    const like = (id, index) => {
      const params = {
        content_id: id,
      };
      store.dispatch("contentLike", { params, index });
    };

    const handleClick = (id) => {
      console.log(id);
      router.push("/detail/" + id);
    };

    const dealDate = (dateString) => {
      return useDateDiff(dateString);
    };
    return {
      onLoad,
      onRefresh,
      imgClick,
      like,
      handleClick,
      dealDate,
      loading,
      finished,
      contents: computed(() => store.state.contents),
      myComments: computed(() => store.state.myCommentData),
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 5vw;
  padding-bottom: 90px;
  --van-pull-refresh-head-text-color: white;
}

.content-list {
  --van-list-text-color: #5190d5;
  background-color: rgba($color: #ffffff, $alpha: 00);
  margin-top: -32px;
}
.group-top {
  margin-bottom: 18px;
  background-color: white;
  padding: 12px 0;
  border-radius: var(--van-cell-group-inset-border-radius);
}
.index {
  padding-top: 20px;
}
.custom_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  margin-top: 10px;
  border-top: 1px solid #e0e0e0;
  align-items: center;
}
.custom_mycoment {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 10px;
}
.list-title {
  color: #1c1c1c;
  font-size: 4vw;
  display: flex;
  line-height: 23px;

  span {
    font-size: 3.6vw;
    padding: 0 5px;
    height: 23px;
    background: #ff8831;
    color: #ffffff;
    border-radius: 12px;
    text-align: center;
    margin-right: 15px;
    box-shadow: 1px 1px 5px #dbdada;
  }
}
.title-more {
  font-weight: bold;
  margin-top: 5px;
}
.list-content {
  font-size: 4vw;
  color: #1c1c1c;
  text-align: left;
  white-space: pre-wrap;
  margin: 8px 0;
}
.custom-box {
  display: flex;
  flex-wrap: wrap;
}
.custom-img {
  display: flex;
}

.custom_imgs {
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}
.content-image {
  --van-grid-item-content-padding: 0;
}
.detail_left {
  font-size: 4vw;
  color: #777777;
  display: flex;
  align-items: center;
  .custom_status {
    font-size: 3.2vw;
    width: 52px;
    height: 20px;
    line-height: 21px;
    border-radius: 12px;
    text-align: center;
    margin-left: 6px;
    background: #dfdfdf;
    color: #9b9b9b;
  }
  .g {
    background: #07c160;
    color: #ffffff;
  }
  .r {
    background: #ee0a24;
    color: #ffffff;
  }
}
.detail_right {
  color: #aaa5a5;
  font-size: 3.2vw;
}
.van-button--default {
  color: #aaa5a5;
  background: var(--van-button-default-background-color);
  border: var(--van-button-border-width) solid
    var(--van-button-default-border-color);
}
.wish-btn {
  padding: 15px 30px;
  text-align: center;
}
.emptyImage-box {
  width: 90%;
  height: 382px;
  margin: 0 auto;
  border-radius: 10px;
}

.custom-img {
  margin: 10px 0;
  width: 100%;
}
.custom-img2 {
  margin: 10px -4px 5px -4px;
  width: 70%;
}
.content-image {
  --van-grid-item-content-padding: 0;
  // display: flex;
  // justify-content: flex-start;
  // margin: 4px;
  // flex-wrap: wrap;
}
</style>
